// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__38PyW","content":"AboutUs_content__JqiKG"};